<script setup>
  import { ref } from 'vue'

  defineProps({
    items: Object
  })
</script>

<template>
  <div
    class="flyout-menu-small-items mt-auto absolute bottom-6 2xl:bottom-0 pb-16"
  >
    <a
      v-for="(item, index) in items"
      :key="index"

      :href="item.url"
      class="font-light flex flex-row items-center cursor-pointer transition-colors !text-white py-2 ~text-lg/2xl hover:opacity-100"
    >
      <span
        class="!bg-transparent"
      >
        <AppIcon
          name="ArrowLink"
        />
      </span>
      {{ item.title }}
    </a>
  </div>
</template>
<style lang="scss" scoped>
  :deep(svg) {
    @apply mr-3 max-w-0 h-4 transition-all duration-300 ease-in-out;
  }
  :deep(svg path) {
    fill: #fff !important;
  }
  a:hover :deep(svg) {
    @apply max-w-8;
  }
</style>
